// extracted by mini-css-extract-plugin
export default {"infoIcon":"scan-request-archive-modal_infoIcon__dA7MT"};